/**
 * AF range — product card scroller + dot pagination
 * Namespace: window.AfRange
 *
 * Created: 2026-08-11 14:50 IST
 * Author: Cursor Agent
 * Reason: Horizontal product track with pill dots on Air Fryer range section
 * Modified: 2026-08-14 18:12 IST — Desktop side arrows to change product cards
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-af-range]';

  function setActiveDot(dots, index) {
    Array.prototype.forEach.call(dots, function (dot, i) {
      var active = i === index;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function nearestCardIndex(scroller, cards) {
    var scrollerLeft = scroller.getBoundingClientRect().left;
    var best = 0;
    var bestDist = Infinity;

    Array.prototype.forEach.call(cards, function (card, i) {
      var dist = Math.abs(card.getBoundingClientRect().left - scrollerLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });

    return best;
  }

  function scrollToCard(scroller, cards, i) {
    if (!cards[i]) return;
    var cardRect = cards[i].getBoundingClientRect();
    var scrollerRect = scroller.getBoundingClientRect();
    var left = scroller.scrollLeft + (cardRect.left - scrollerRect.left);
    if (typeof scroller.scrollTo === 'function') {
      scroller.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      scroller.scrollLeft = left;
    }
  }

  function initRange(root) {
    if (!root || root.getAttribute('data-af-ready') === '1') return;

    var scroller = root.querySelector('[data-af-range-scroller]');
    var cards = root.querySelectorAll('[data-af-range-card]');
    var dots = root.querySelectorAll('[data-af-range-dot]');

    if (!scroller || !cards.length) return;

    root.setAttribute('data-af-ready', '1');

    var ticking = false;
    var arrows = null;

    function syncFromScroll() {
      var i = nearestCardIndex(scroller, cards);
      if (dots.length) setActiveDot(dots, i);
      if (arrows) arrows.syncFromScroller(scroller);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncFromScroll();
      });
    }

    function goBy(delta) {
      var i = nearestCardIndex(scroller, cards) + delta;
      i = Math.max(0, Math.min(cards.length - 1, i));
      scrollToCard(scroller, cards, i);
      if (dots.length) setActiveDot(dots, i);
      if (arrows) arrows.syncFromScroller(scroller);
    }

    if (dots.length) {
      Array.prototype.forEach.call(dots, function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-af-index'), 10);
          if (isNaN(i) || !cards[i]) return;
          scrollToCard(scroller, cards, i);
          setActiveDot(dots, i);
          if (arrows) arrows.syncFromScroller(scroller);
        });
      });
    }

    /*
     * Modified: 2026-08-14 18:12 IST
     * Author: Cursor Agent
     * Reason: Desktop arrows — step Range product cards
     */
    if (window.AfArrowNav && typeof window.AfArrowNav.create === 'function' && cards.length > 1) {
      arrows = window.AfArrowNav.create(root, {
        prevLabel: 'Previous product',
        nextLabel: 'Next product',
        onPrev: function () {
          goBy(-1);
        },
        onNext: function () {
          goBy(1);
        }
      });
    }

    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', syncFromScroll);
    syncFromScroll();
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(initRange);
  }

  window.AfRange = {
    init: initAll,
    initOne: initRange
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root =
      event.target.querySelector(ROOT_SEL) ||
      (event.target.matches && event.target.matches(ROOT_SEL) ? event.target : null);
    if (root) {
      root.removeAttribute('data-af-ready');
      initRange(root);
    }
  });
})();
